<template>
  <div class="">
    <aside class="left">
      <section class="change">
        <p @click='goUrl("/aiList",1)' :class="activeIndex=='/aiList'?'active':''">智能志愿</p>
        <p @click='goUrl("/artificialList?type=score",2)'
          :class="activeIndex=='/artificialList?type=score'?'active':''">人工志愿
        <p @click='goUrl("/artificialList?type=equal",2)'
          :class="activeIndex.indexOf('/artificialList?type=equal')>-1?'active':''" v-show="teacher_show=='true'">同位分报志愿
        <p @click='goUrl("/artificialList?type=diff",2)'
          :class="activeIndex.indexOf('/artificialList?type=diff')>-1?'active':''" v-show="teacher_show=='true'">线差报志愿
        <p @click='goUrl("/artificialList?type=rank",2)'
          :class="activeIndex.indexOf('/artificialList?type=rank')>-1?'active':''" v-show="teacher_show=='true'">位次报志愿
        <p @click='goUrl("/artificialList?type=pnmp",2)'
          :class="activeIndex.indexOf('/artificialList?type=pnmp')>-1?'active':''" v-show="teacher_show=='true'">PNMP报志愿
        </p>
        <p @click='goUrl("/artificialList?type=self",2)'
          :class="activeIndex.indexOf('/artificialList?type=self')>-1?'active':''">自主志愿
        </p>
        <!-- <p @click='goUrl("/form",3)' :class="activeIndex=='/form'?'active':''">我的志愿表</p> -->
      </section>
      <section class="info" v-if="$route.query.id">
        <div class="head">当前信息</div>
        <p>高考地区：{{userInfo.province_name}}</p>
        <p>高考科目：{{data.enroll_type}}</p>
        <p>高考分数：{{data.score}}</p>
        <p>批次：{{data.batch_name}}</p>
        <!-- <button>
          修改信息
        </button> -->
        <div class="line">--------省控线--------</div>
        <div class="score">
          <p>{{data.province_line}}分</p>
          <p>---------------</p>
          <p>{{data.batch_name}}</p>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: '',
        userInfo: null,
        data: [],
        teacher_show: false
      }
    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    mounted() {

      this.activeIndex = localStorage.getItem('activeurl')
      console.log(this.activeIndex)
      if (localStorage.getItem('userInfo')) {
        this.$http.getUserInfo().then(res => {
          this.userInfo = res.data
        })
      }
      if (localStorage.getItem('teacher_show')) {
        this.teacher_show = localStorage.getItem('teacher_show')
      }
      this.$forceUpdate()
    },
    methods: {
      goUrl(url, num) {
        console.log(url)
        this.activeIndex = url
        localStorage.setItem('activeurl', url)
        this.$router.push({
          path: url
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .change {
    width: 205px;
    // height: 351px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .current {
    width: 324px;
    height: 39px;
    line-height: 39px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #FA6002;

    span {
      display: inline-block;
    }

    .dangqian {
      width: 236px;
    }
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #C10B17
  }

  .line {
    margin: 25px 0 18px 0;
    color: #C10B17
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;
    border: 1px solid #EDEDED;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #C10B17;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C10B17;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    // height: 351px !important;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #C10B17
  }

  .line {
    margin: 25px 0 18px 0;
    color: #C10B17
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #C10B17;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C10B17;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    // height: 101px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .active {
    background: #C10B17;
    color: #FFFFFF;

  }

  .tabactive {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #C10B17;
    border-bottom: 1px solid #C10B17;
  }

  .type {
    margin-top: 22px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;

    span {
      margin: 0 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/volLeft.vue